import api from '../api'

export default {
  login (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/user/login', data, successCallback, errCallback, isShowErrMsg)
  },
  userInfo (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/user/getUserInfo2', data, successCallback, errCallback, isShowErrMsg)
  },
  getHotCity (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/front/v2/baseinfo/city/queryHotCity', data, successCallback, errCallback, isShowErrMsg)
  },
  getToken (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/common/getToken', data, successCallback, errCallback, isShowErrMsg)
  },
  getAllXFCity (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    // api.get('api/front/v2/baseinfo/city/searchAllCity', data, successCallback, errCallback, isShowErrMsg)
    api.get('api/appclient/v2/frontregion/searchAllCity', data, successCallback, errCallback, isShowErrMsg)
  },
  wxAutoSign (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/weixin/autoRegisterAndLogin', data, successCallback, errCallback, isShowErrMsg)
  },
  wxToken (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('https://api.weixin.qq.com/sns/oauth2/access_token', data, successCallback, errCallback, isShowErrMsg)
  },
  register (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/user/registerUser', data, successCallback, errCallback, isShowErrMsg)
  },
  login (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/user/userLogin', data, successCallback, errCallback, isShowErrMsg)
  },
  resetPassword (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/user/resetPassword', data, successCallback, errCallback, isShowErrMsg)
  },
  getAuthCode (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/verifycode/get', data, successCallback, errCallback, isShowErrMsg)
  },
  getUserInfo (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/user/getUserInfo', data, successCallback, errCallback, isShowErrMsg)
  },
  getAllCity (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/common/v2/baseinfo/cityAll', data, successCallback, errCallback, isShowErrMsg)
  },
  cacheLocation (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/user/cacheLoctionAddress', data, successCallback, errCallback, isShowErrMsg)
  },
  getStationList (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    // api.get('api/appclient/v2/baseinfo/delivery/stationList', data, successCallback, errCallback, isShowErrMsg)
    // api.get('api/backend/v2/baseinfo/delivery/stations', data, successCallback, errCallback, isShowErrMsg)
    api.get('api/appclient/v2/baseinfo/delivery/stationList', data, successCallback, errCallback, isShowErrMsg)
  },
  logout (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/user/logout', data, successCallback, errCallback, isShowErrMsg)
  },
  getProductType (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/product/category', data, successCallback, errCallback, isShowErrMsg)
  },
  getWXCode (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx08dc80f9bee15b99&redirect_uri=http%3A%2F%2Fwap.blissmall.net%2F&response_type=code&scope=snsapi_base#wechat_redirect', data, successCallback, errCallback, isShowErrMsg)
    // api.get('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx674e8a68779fd71f&redirect_uri=http%3A%2F%2Fqa002.wap.blissmall.net%2F&response_type=code&scope=snsapi_base#wechat_redirect', data, successCallback, errCallback, isShowErrMsg)
  },
  getIsRegist (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/user/mobile/checkRegister/'+data, {}, successCallback, errCallback, isShowErrMsg)
  },
  getPayInfo (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/payment/blissmall/payCharge', data, successCallback, errCallback, isShowErrMsg)
    // api.post('api/appclient/v2/payment/blissmall/payCharge', data, successCallback, errCallback, isShowErrMsg)
  },
  getPayResult (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/payment/blissmall/chargeResult', data, successCallback, errCallback, isShowErrMsg)
  },
  verifySMS (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/verifycode/validate', data, successCallback, errCallback, isShowErrMsg)
  }
}



// WEBPACK FOOTER //
// ./src/api/common/api.common.js